// Browser-only practice, with no requests or persisted answers.
export const trainerAnswerMatches = (answer, item) => {
  const normalized = answer.trim().toLowerCase();
  return !!normalized && [item.answer, ...item.answer.split("/"), ...(item.accepted || [])]
    .some(expected => expected.toLowerCase() === normalized);
};

export const selectTrainerRound = (items, filter, random = Math.random) => {
  const pool = items.filter(item => filter === "all" || item.filter === filter);
  if (!pool.length) return [];
  const round = [];
  // Small kana rows still give ten questions. Exhaust each shuffled pool
  // before repeating, and avoid consecutive repeats when possible.
  while (round.length < 10) {
    const shuffled = [...pool];
    for (let i = shuffled.length - 1; i > 0; i -= 1) {
      const j = Math.floor(random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    if (shuffled.length > 1 && shuffled[0] === round[round.length - 1]) shuffled.push(shuffled.shift());
    round.push(...shuffled.slice(0, 10 - round.length));
  }
  return round;
};

const initScriptTrainers = () => {
  document.querySelectorAll("[data-script-trainer]").forEach(root => {
    if (root.dataset.trainerInitialized) return;
    root.dataset.trainerInitialized = "true";
    const items = JSON.parse(root.dataset.items);
    const find = name => root.querySelector(`[data-trainer-${name}]`);
    const buttons = [...root.querySelectorAll("[data-trainer-answer]")];
    const input = find("input");
    const form = find("form");
    let filter = root.dataset.kind === "hangul" ? "letters" : "all";
    let round = [];
    let index = 0;
    let missed = [];
    let checked = false;
    const show = () => {
      checked = false;
      const item = round[index];
      find("progress").textContent = `${index + 1} / ${round.length}`;
      find("prompt").textContent = item.prompt;
      find("meaning").textContent = root.dataset.kind === "der_die_das" ? item.meaning : "";
      find("feedback").textContent = "";
      find("next").hidden = true;
      buttons.forEach(button => { button.disabled = false; });
      if (input) { input.value = ""; input.disabled = false; form.querySelector("button").disabled = false; input.focus(); }
      else buttons[0].focus();
    };
    const start = () => {
      round = selectTrainerRound(items, filter);
      if (!round.length) return;
      index = 0;
      missed = [];
      find("start").hidden = true;
      find("results").hidden = true;
      find("round").hidden = false;
      show();
    };
    const answer = value => {
      if (checked || !round[index] || find("round").hidden || !value.trim()) return;
      checked = true;
      const item = round[index];
      const correct = trainerAnswerMatches(value, item);
      if (!correct) missed.push(item);
      find("feedback").textContent = `${correct ? "✓" : "✗"} ${item.answer}${item.rule ? ` (${item.rule})` : ""}`;
      find("meaning").textContent = item.meaning || "";
      buttons.forEach(button => { button.disabled = true; });
      if (input) { input.disabled = true; form.querySelector("button").disabled = true; }
      find("next").hidden = false;
      find("next").focus();
    };
    find("print").addEventListener("click", () => window.print());
    find("start").hidden = false;
    find("start").addEventListener("click", start);
    find("again").addEventListener("click", start);
    buttons.forEach(button => button.addEventListener("click", () => answer(button.dataset.trainerAnswer)));
    if (form) form.addEventListener("submit", event => { event.preventDefault(); answer(input.value); });
    root.querySelectorAll("[data-trainer-filter]").forEach(button => {
      button.addEventListener("click", () => {
        filter = button.dataset.trainerFilter;
        root.querySelectorAll("[data-trainer-filter]").forEach(chip => chip.setAttribute("aria-pressed", String(chip === button)));
        root.querySelectorAll("[data-trainer-row]").forEach(row => { row.hidden = filter !== "all" && row.dataset.filter !== filter; });
        checked = false;
        find("start").hidden = false;
        find("round").hidden = true;
        find("results").hidden = true;
      });
    });
    find("next").addEventListener("click", () => {
      if (!checked) return;
      index += 1;
      if (index < round.length) { show(); return; }
      checked = false;
      find("round").hidden = true;
      find("results").hidden = false;
      find("score").textContent = root.dataset.result.replace("%{score}", String(round.length - missed.length)).replace("%{total}", String(round.length));
      find("missed").replaceChildren();
      missed.forEach(item => {
        const li = document.createElement("li");
        li.textContent = `${item.prompt}: ${item.answer}${item.meaning ? ` (${item.meaning})` : ""}`;
        find("missed").append(li);
      });
      find("review").hidden = !missed.length;
      find("again").focus();
    });
  });
};

document.addEventListener("DOMContentLoaded", initScriptTrainers);
document.addEventListener("turbo:load", initScriptTrainers);
